angular.module('Itao.IndicatorMap').directive('export', ['mapConfig', 'ExportService', 'HyperionDataService','$http', function (mapConfig, ExportService, HyperionDataService, $http) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'export.html',
    scope: {
      types: '=',
      data: '=',
      filename: '@',
      source: '@'
    },
    link: function (scope, element) {
      var $contentContainer = jQuery('.itao-pluginView:first');
      scope.exportWidget = function (type) {
        if (type == 'csv') {
          ExportService.exportAsCsv(
            scope.data,
            type,
            scope.filename
          );
        } else if (type == 'xlsx') {
          ExportService.exportAsXlsx(
            scope.data,
            type,
            scope.filename
          );
        } else {
          ExportService.exportAsImage(
            $contentContainer.html(),
            type,
            scope.filename,
            [Math.ceil($contentContainer.width()), Math.ceil($contentContainer.height())],
            scope.source
          );
        }
      };

      scope.htmlToPdf = function (id) {
        $http.get('/_assets/19afb7c62e901835de82505ec5bff8a5/Css/reportExport.css')
          .then(function(response) {
            var localStylesContent = response.data;
            var htmlString = document.getElementById(id).innerHTML;

            var context = {
              html: htmlString,
              styles: localStylesContent,
              filename: 'report_export.pdf'
            };

            var code = `module.exports=async({page: page, context:context})=>{
              await page.setContent('<html><head><style>' + context.styles + '</style></head><body>' + context.html + '</body></html>');

              var output = await page.pdf({
                path: 'output.pdf',
                format: 'A4',
                landscape: true,
                printBackground: true,
                margin: { top: 40, right: 40, bottom: 40, left: 40 },
              });
              return{data:output,type:'application/pdf'}
            }`;

            HyperionDataService.convertHtml(code, context).then(function(pathData) {
              var link = document.createElement('a');
              link.href = window.origin + '/' + pathData.data;
              link.target = '_blank';
              link.click();
            }).catch(function (error) {
              console.error('Error loading execute browserless script:', error);
            });
          })
          .catch(function(error) {
            console.error('Error loading local styles:', error);
          })
      };
    }
  };
}]);
